import React, {useRef} from 'react';
import './OnlinePvP.scss';
import Board from "../../Board/Board";
import {_} from "../../../models/Game.model";
import SidebarNav from "../../Nav/NavSidebar";
import {ArrowClockwise, CloudMinus} from "react-bootstrap-icons";

interface Props {
    onSwitchGame: () => void;
}

const OnlinePvP = (props: Props) => {
    const ref = useRef<any>();

    const reset = () => {
        ref.current.reset();
    }

    const onBoardClick = (row: number, col: number) => {
        ref.current.update(row, col);
    }

    return (
        <section className="OnlinePvP">
            <SidebarNav>
                <button onClick={reset}><ArrowClockwise />New</button>
                <button onClick={props.onSwitchGame}><CloudMinus />Local PvP</button>
            </SidebarNav>
            <header className="Header">
                Online PvP
            </header>
            <div className="GameBoard">
                <Board id={1} ref={ref} player={_} onClick={onBoardClick}/>
            </div>
        </section>
    );
}

export default OnlinePvP;
